module.exports = __webpack_public_path__ + "img/gmodhq.8106015a.webp";